import Tween from "tween.ts";
import Animation from "./Animation";


export default class SwapSprite extends Animation {
  constructor(startScale: number, targetScale: number, onUpdate: (v: number) => void, onComp = () => { }) {
    super();
    const scale = {v: startScale }
    new Tween.Tween(scale)
      .to({ v: targetScale }, 300)
      .easing(Tween.Easing.Elastic.Out)
      .onUpdate((s: { v: number }) => onUpdate(s.v))
      .onComplete(() => onComp())
      .start();
  }
}